import React from "react";

const AboutScreen = () => {
  return <div>About</div>;
}

export default AboutScreen;